import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die ColumnLayoutItem
 */
export default class ColumnLayoutItemViewModel extends ControlViewModel {

    /**
     * Das Factory-Tuple
     */
    public tuple: any;

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number | string>;

    /**
     * Gibt an, ob das Item sichtbar ist
     */
    public isVisible: KnockoutComputed<boolean>;

    /**
     * Das ViewModel für die ColumnLayoutItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.tuple = this.paramOrDefault(params.tuple, null);
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);
        this.isVisible = this.defineComputed(() => {
            let tuple = this.tuple;

            if (tuple == null) {
                return true;
            }

            return tuple.factory.isVisible();
        });
    }
}

ComponentManager.setViewModel('ColumnLayoutItemViewModel', ColumnLayoutItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');